import { render, staticRenderFns } from "./CreateIndex.vue?vue&type=template&id=bce5958e&"
import script from "./CreateIndex.vue?vue&type=script&lang=js&"
export * from "./CreateIndex.vue?vue&type=script&lang=js&"
import style0 from "./CreateIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports